import { Alert, Breadcrumb, Callout, Card, Col, EventHandler, InputField, Label, OutlineButton, PrimaryButton, ReactSelectBox, Row } from 'client/CommonComponents'
import './Reports.scss'
import permissions, { isAuthorized } from "client/utils/Permissions";
import addCategory from '../../../assets/images/Add.svg'
import editIcon from '../../../assets/images/Edit.svg'

import icon_1 from "../../../assets/images/Internal 1_List.svg"
import icon_2 from "../../../assets/images/Internal 2_List.svg"
import icon_3 from "../../../assets/images/Internal 3_List.svg"
import icon_4 from "../../../assets/images/Internal 4_List.svg"
import icon_5 from "../../../assets/images/External 5_List.svg"
import icon_6 from "../../../assets/images/External 6_List.svg"
import icon_7 from "../../../assets/images/External 7_List.svg"
import icon_8 from "../../../assets/images/External 8_List.svg"
import CancelConfirmationPopup from 'client/CommonComponents/DialogBox/CancelConfirmationPopup';
import DraggableReportList from './DraggableReportList';
import { CONSTANTS } from 'client/utils/constants';


const AddEditCategory = (props: any) => {
    const {
        handleCategoryNameChange,
        categoryName,
        categoryError,
        hideCategoryPopup,
        saveCategory,
        className
    } = props
    return (
        <Row className={className}>
            <Col sm={12} md={12} lg={12} className='mb-3'>
                <InputField
                    name='categoryName'
                    placeholder='Enter Category Name'
                    onChange={handleCategoryNameChange}
                    value={categoryName}
                 data-attribute="Reports_categoryName_Input" />
                {categoryError ? <p className='validMessage'>{categoryError}</p> : null}
            </Col>
            <Col sm={12} md={12} lg={12}>
                <div className='pull-right'>
                    <OutlineButton text='Cancel' onClick={() => hideCategoryPopup()}  data-attribute="Reports_Default_Button" />
                    <PrimaryButton text='Save' onClick={() => saveCategory()}  data-attribute="Reports_Default_Button_2" />
                </div>
            </Col>
        </Row>
    )
}

const AddEditReportLinkContent = (props: any) => {
    const {
        iconList,
        cancelAddEditLinkPopup,
        saveLink,
        index,
        linkTypeOptions,
        handleChange,
        onChangeLinkType,
        onSelectIcon,
        values,
        errors,
        className
    } = props
    return (
        <Row className={className}>
            <Col sm={12} md={12} lg={12} className='mb-3'>
                <Label required data-attribute="Reports_Default_Label">Link Text</Label>
                <InputField
                    name='linkText'
                    placeholder='Enter Text'
                    onChange={handleChange}
                    value={values?.linkText}
                    disabled={values?.linkText === CONSTANTS.REPORTS.BARCODE_REPLACEMENT_REPORT || values?.linkText === CONSTANTS.REPORTS.E1_UPLOAD_TEMPLATE}
                 data-attribute="Reports_linkText_Input" />
                {errors?.linkText ? <p className='validMessage'>{errors?.linkText}</p> : null}
            </Col>
            <Col sm={12} md={12} lg={12} className='mb-3'>
                <Label required data-attribute="Reports_Default_Label_2">Link Type</Label>
                <ReactSelectBox
                    name='linkType'
                    options={linkTypeOptions}
                    value={values?.linkType}
                    onChange={onChangeLinkType}
                 data-attribute="Reports_linkType_SearchSelectBox" />
                {errors?.linkType ? <p className='validMessage'>{errors?.linkType}</p> : null}
            </Col>
            <Col sm={12} md={12} lg={12} className='mb-3'>
                <Label required data-attribute="Reports_Default_Label_3">Link URL</Label>
                <InputField
                    name='linkURL'
                    placeholder='Enter URL'
                    onChange={handleChange}
                    value={values?.linkURL}
                    disabled={values?.linkText === CONSTANTS.REPORTS.BARCODE_REPLACEMENT_REPORT || values?.linkText === CONSTANTS.REPORTS.E1_UPLOAD_TEMPLATE}
                 data-attribute="Reports_linkURL_Input" />
                {errors?.linkURL ? <p className='validMessage'>{errors?.linkURL}</p> : null}
            </Col>
            <Col sm={12} md={12} lg={12}>
                <Label required className='mb-1' data-attribute="Reports_Default_Label_4">Add Icon</Label>
                {
                    iconList?.map((item: any, index: any) => {
                        return (
                            <EventHandler onEvent={() => onSelectIcon(`icon_${item.id}`)} data-attribute={`Reports_${(item?.id || index).toString().replace(/[^a-zA-Z0-9]+/g, '_')}_Icon_EventHandler`}>
                                <span
                                    className={`add-icon icon_${item.id} ${values?.icon === 'icon_' + item.id ? 'active' : ''}`}
                                    key={item.id}
                                >
                                </span>
                            </EventHandler>
                        )
                    })
                }
                {errors?.icon ? <p className='validMessage'>{errors?.icon}</p> : null}
            </Col>
            <Col sm={12} md={12} lg={12}>
                <div className='pull-right'>
                    <OutlineButton text='Cancel' onClick={() => cancelAddEditLinkPopup(index)}  data-attribute="Reports_Default_Button_3" />
                    <PrimaryButton text='Save' onClick={() => saveLink()}  data-attribute="Reports_Default_Button_4" />
                </div>
            </Col>
        </Row>
    )
}

const Reports = (props: any) => {
    const {
        showAlert,
        deleteReportLink,
        setUserAction,
        userAction,
        showCategoryPopup,
        setShowCategoryPopup,
        handleCategoryNameChange,
        categoryName,
        categoryError,
        saveCategory,
        hideCategoryPopup,
        editCategory,
        editCategoryId,
        popupContent,
        handleDownloadReport
    } = props

    const getlinkIcon = (icon: string) => {
        switch (icon) {
            case 'icon_1':
                return icon_1
            case 'icon_2':
                return icon_2
            case 'icon_3':
                return icon_3
            case 'icon_4':
                return icon_4
            case 'icon_5':
                return icon_5
            case 'icon_6':
                return icon_6
            case 'icon_7':
                return icon_7
            case 'icon_8':
                return icon_8
            default:
                return icon_1
        }
    }

    const getAlertText = (userAction: string) => {
        const alertTextMap = {
            'save-true': "Report link saved sucessfully",
            'save-false': "Error while saving Report link",
            'update-true': "Report link updated sucessfully",
            'update-false': "Error while updating Report link",
            'delete-true': "Report link deleted sucessfully",
            'delete-false': "Error while deleting Report link",
            'addCategory-true': "Category saved sucessfully",
            'addCategory-false': "Error while saving Category",
            'updateCategory-true': "Category updated sucessfully",
            'updateCategory-false': "Error while updating Category"
        };

        return alertTextMap[`${userAction}-${props?.isLinkSavedFlag}` as keyof typeof alertTextMap];
    }

    return (
        <div className='CustomerMyOrder reports mt-1'>
            <div className='breadcrumb-toolbar'>
                <div className='order-1'><Breadcrumb items={props.breadcrumlist} maxDisplayedItems='5'  data-attribute="Reports_Default_Breadcrumb" /></div>
            </div>
            <Alert
                className={`branch-alert-message-stepper mb-3 ${props?.isLinkSavedFlag ? "success-alert" : "error-alert"}`}
                showAlert={showAlert}
                type={props?.isLinkSavedFlag ? "success" : "error"}
                text={getAlertText(userAction)}
                dismissAlert={props.dismissSuccessAlert}
             data-attribute="Reports_Default_Alerts" />
            <Card data-attribute="Reports_Default_Card">
                <div className='create-new-order-container'>
                    <div className='grid-block pt-3 pb-0'>
                        <div className='mb-3 top-section clearfix'>
                            <p className='pull-left blueLabel mt-2'>REPORTS DASHBOARD</p>
                                <EventHandler onEvent={() => {
                                    setShowCategoryPopup(true);
                                    setUserAction('addCategory')
                                }} data-attribute="Reports_Default_EventHandler_2">
                                    <PrimaryButton
                                        text='Add Category'
                                        id='addCategory'
                                        className='pull-right'
                                        disabled={!isAuthorized(permissions.CreateUpdateReports)}
                                     data-attribute="Reports_Default_Button_5" />
                                </EventHandler>
                            {showCategoryPopup &&
                                <Callout
                                    targetId={editCategoryId ? `editCategory_${editCategoryId}` : 'addCategory'}
                                    toggleIsCalloutVisible={() => hideCategoryPopup()}
                                    calloutMaxHeight={300}
                                 data-attribute="Reports_Default_Callout">
                                    <AddEditCategory
                                        handleCategoryNameChange={handleCategoryNameChange}
                                        categoryName={categoryName}
                                        categoryError={categoryError}
                                        setShowCategoryPopup={setShowCategoryPopup}
                                        saveCategory={saveCategory}
                                        hideCategoryPopup={hideCategoryPopup}
                                        className='add-edit-category'
                                    />
                                </Callout>
                            }
                        </div>
                        <div className='bottom-section'>
                            {
                                props?.reportList?.map((item: any) => {
                                    return (
                                        <div className='report-container' key={item?.categoryId}>
                                            <div className='header-block clearfix'>
                                                <p className='blueLabel pull-left'>{item?.categoryName.toUpperCase()}</p>
                                                {isAuthorized(permissions.CreateUpdateReports) &&
                                                    <EventHandler onEvent={() => editCategory(item?.categoryName, item?.categoryId)} data-attribute={`Reports_${(item?.categoryName || item?.categoryId).toString().replace(/[^a-zA-Z0-9]+/g, '_')}_Edit_EventHandler`}>
                                                        <img
                                                            id={`editCategory_${item?.categoryId}`}
                                                            src={editIcon}
                                                            alt='Edit'
                                                            title='Edit Category'
                                                            className='ms-2 edit-category-icon'
                                                        />
                                                    </EventHandler>
                                                }
                                                <div className='edit-category-toggle'>
                                                    {
                                                        isAuthorized(permissions.CreateUpdateReports) &&
                                                        <EventHandler onEvent={(e: any) => { props?.onClickAddEditCategory(e, 'item_'+item?.categoryId, item?.categoryId); setUserAction('save') }} data-attribute={`Reports_${(item?.categoryName || item?.categoryId).toString().replace(/[^a-zA-Z0-9]+/g, '_')}_Add_EventHandler`}>
                                                            <img src={addCategory} alt='Add Link' id={`item_${item?.categoryId}`} />
                                                        </EventHandler>
                                                    }
                                                </div>
                                                {props?.collapse?.state &&
                                                    <Callout
                                                        targetId={props?.collapse?.index}
                                                        calloutMaxHeight={300}
                                                     data-attribute="Reports_Default_Callout_2">
                                                        <AddEditReportLinkContent
                                                            iconList={props?.iconList}
                                                            cancelAddEditLinkPopup={props?.cancelAddEditLinkPopup}
                                                            linkTypeOptions={props?.linkTypeOptions}
                                                            saveLink={props?.saveLink}
                                                            handleChange={props?.handleChange}
                                                            onChangeLinkType={props?.onChangeLinkType}
                                                            onSelectIcon={props?.onSelectIcon}
                                                            values={props?.values}
                                                            errors={props?.errors}
                                                            key={`item_${item?.categoryId}`}
                                                            index={item?.categoryId}
                                                            className='add-edit-link-popup'
                                                        />

                                                    </Callout>
                                                }
                                            </div>
                                            <div className='content-block'>
                                                <ul>
                                                    <DraggableReportList
                                                        listItems={item?.reports}
                                                        getlinkIcon={getlinkIcon}
                                                        isAuthorized={isAuthorized}
                                                        setUserAction={setUserAction}
                                                        deleteReportLink={deleteReportLink}
                                                        onClickAddEditCategory={props?.onClickAddEditCategory}
                                                        key={item?.categoryId}
                                                        categoryId={item?.categoryId}
                                                        handleDownloadReport={handleDownloadReport}
                                                    />
                                                </ul>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
            </Card>

            {popupContent.isDialogVisible ?
                <CancelConfirmationPopup
                    hideDialog={!popupContent.isDialogVisible}
                    onDismiss={popupContent.hideDialog}
                    Popupcontent={popupContent}
                    popupOutlinebtnOnclick={() => popupContent.popupOutlinebtnOnclick()}
                    popupPrimarybtnOnclick={() => popupContent.popupPrimarybtnOnclick()}
                /> : ""}
        </div>
    )
}

export default Reports
